import { Testimonial } from '../testimonials.data';
import * as styles from './Testimonials.css';

type TestimonialCardProps = {
  testimonial: Testimonial;
};

const toInitials = (name: string): string => {
  return name
    .split(' ')
    .map((value) => value[0]?.toUpperCase() ?? '')
    .slice(0, 2)
    .join('');
};

export const TestimonialCard = ({ testimonial }: TestimonialCardProps) => {
  return (
    <article className={styles.testimonialCard}>
      <p className={styles.testimonialQuote}>
        &ldquo;{testimonial.quote}&rdquo;
      </p>

      <div className={styles.testimonialFooter}>
        <div className={styles.testimonialAvatar}>
          {testimonial.avatarSrc ? (
            <img
              src={testimonial.avatarSrc}
              alt={`${testimonial.authorName} avatar`}
              className={styles.testimonialAvatarImage}
            />
          ) : (
            <span className={styles.testimonialAvatarText}>
              {toInitials(testimonial.authorName)}
            </span>
          )}
        </div>

        <div className={styles.testimonialAuthorBlock}>
          <p className={styles.testimonialAuthorName}>
            {testimonial.authorName}
          </p>
          <p className={styles.testimonialAuthorRole}>
            {testimonial.authorRole}
          </p>
        </div>
      </div>
    </article>
  );
};
